module.exports = __webpack_public_path__ + "static/img/yeswecan0027.c0b2c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0027.png
// module id = 602
// module chunks = 1